<template>
  <div :class="$style.snackContainer">
    <transition-group
      :enter-active-class="$style.enterActive"
      :enter-from-class="$style.enterFrom"
      :leave-active-class="$style.leaveActive"
      :leave-to-class="$style.leaveTo"
      :move-class="$style.move"
      appear
    >
      <SnackProvider v-for="snack in snacks" :key="snack.id" :class="$style.snackProvider" :snack="snack">
        <component
          :is="snack.component"
          :key="snack.id"
          :class="$style.snack"
          v-bind="snack.props"
          v-on="snack.listeners"
        />
      </SnackProvider>
    </transition-group>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { SnackProvider, useSnackbar } from "vue-haystack";

const store = useSnackbar();

const snacks = computed(() => {
  return store.items.value;
});
</script>

<style module lang="scss">
$duration-enter: 0.15s;
$duration-leave: 0.25s;
$ease-enter: cubic-bezier(0.15, 0.8, 0.55, 1.1);
$ease-leave: cubic-bezier(0.4, 0, 0.2, 1);

@mixin snack-transition($duration, $easing) {
  transition:
    opacity $duration $easing,
    transform $duration $easing;
}

.snackContainer {
  z-index: 600;
  position: fixed;

  bottom: var(--space-component-padding-xLarge);
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  gap: var(--space-component-gap-small);
  pointer-events: none;

  .snackProvider {
    .snack {
      pointer-events: all;
    }
  }
}

.enterActive {
  @include snack-transition($duration-enter, $ease-enter);
}

.enterFrom {
  transform: translateY(48px) scale(0.5);
  opacity: 0;
}

.move {
  transition: transform $duration-leave $ease-leave;
}

.leaveActive {
  position: absolute;
  @include snack-transition($duration-leave, $ease-leave);
}

.leaveTo {
  opacity: 0;
  transform: translateY(16px) scale(0.96);
}
</style>
